import { render, staticRenderFns } from "./ClientReportBike.vue?vue&type=template&id=56cf7717"
import script from "./ClientReportBike.vue?vue&type=script&lang=js"
export * from "./ClientReportBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports